/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion -- 컨덕터 tsconfig(noUncheckedIndexedAccess) 에선 필요한 인덱스 단언(days[0]!). dev tsconfig 에선 불필요로 보여 경고만 난다 */
// [V2] 출고일정관리(MWMS) 표시 부품 — 컨덕터 소유 이식본(2026-09-10 ⑤ 1-C ③, 문서 42 §2·§3).
//
// 왜 여기로 옮겼나: 종전엔 DS `components-desktop/mwms/*`(0.8.0 에서 기존 폴더를 지우며 살려 옮긴 통짜 9종 —
//   DispatchSchedule·BaseOpsCard/ScenarioCardList·DispatchOpsGrid·DispatchPriority·DispatchGlobalPriority·RankDragList·
//   WaitSelect·DowPicker·GlobalPrioSlots + 내부 부품 DateNav·CapaBar·MetricCard)를 소비했다.
//   사용자 확정 2026-09-10 "전부 지금 요소로 분해해서 만들어". 분해 결과:
//     · DispatchSchedule(.mwds 셸)          → 상태 스코프(`.mwds` 래퍼는 CSS 스코프라 스코프가 그대로 갖는다)
//     · DateNav([오늘] ‹ › + 라벨·피커 + Tag/Alert) → 버튼 3개는 트리 core.Button(폼 버스 formAction), 라벨+피커+Tag/Alert 는
//                                              **이 파일** DispatchDateLabel(시임 — view·오프셋에서 파생되는 문구)
//     · DispatchOpsGrid / DispatchPriority   → 툴바를 뺀 표 본문만 **이 파일**(시임 — 셀이 상태에서 파생되는 반복)
//     · BaseOpsCard/ScenarioCardList / GlobalPriority → **이 파일**(시임 — 카드 목록은 데이터 반복, 글로벌은 표 폭이 Alert 폭을 정하는
//                                              CSS 트릭(width:0·min-width:100%)이라 StyleOverride 로 못 편다)
//     · RankDragList / WaitSelect / DowPicker / GlobalPrioSlots → **이 파일**(모달 콘텐츠의 폼 컨트롤 — 포인터 드래그·
//                                              blur 보정·칩 토글·교차 disabled 같은 동작이 붙어 있어 요소 prop 으로 못 편다)
// 무엇으로 분류하나: **컨덕터 시임**(`CONDUCTOR_SEAM_TYPES` · 판정 장부 verdict `seam`). DS 요소가 아니다.
// 시각·동작은 DS 원본 그대로 옮겼다(값 변경 0 — 전후 픽셀 대조로 확인). 바뀐 것은 import 경로뿐이다:
//   · antd 직접 import → `core.*`(규칙 5 — 자산화된 것은 antd 로 돌아가지 않는다)
//   · './DispatchScheduleShared' → './dispatchShared'(컨덕터 소유 모델, 동반 파일로 같이 실린다)
//   · DS elements/Button·Alert → core.Button·core.Alert(같은 실물)
// CSS 는 dispatchParts.css — DS DispatchSchedule.css·DowPicker.css·MetricCard.css 중 이 파일이 쓰는 규칙만 verbatim.
//   단 하나의 셀렉터 조정: 구 `.mwds .datenav …`(툴바 행 클래스)는 트리 core.Flex 가 됐으므로 라벨·피커·Tag·Alert 규칙을
//   `.mwds .dnlabel …`(이 파일의 DispatchDateLabel 래퍼, display:contents)로 옮겼다. 값은 그대로.
import { Fragment, useEffect, useRef, useState, type CSSProperties, type ReactNode } from 'react'
import dayjs, { type Dayjs } from 'dayjs'
import { core } from '@musinsa/pbo-core'
// 타입만 — antd TimePicker prop 전면(TimeField 가 값 축만 문자열로 바꾼다). 런타임 import 는 core 재노출 하나뿐이다.
// ⚠️ 이 타입이 **소비처 antd** 로 해석된다 — 동반 파일은 변환 없이 dev 로 나간다.
//   실측 2026-09-15 mwms-fe: 런타임은 core→antd 5.29.3 인데 타입은 루트 antd 6.5.0 을 봐서
//   TimePicker `prefix` 가 ReactNode vs string 으로 어긋났다(핸드오프 타입체크 TS2322).
//   ⛔ core 파생(`ComponentProps<typeof TimePicker>`)으로 바꾸는 **단순 치환은 안 된다** —
//     core 는 antd 재수출이라 선언 출력이 pnpm 트리 깊은 이름(rc-picker·PurePanelInterface)을
//     참조하게 되어 CI 의 `tsc -b` 가 TS2742/TS4023 으로 깨진다(2026-09-15 base 실측).
//     ⓘ 로컬에서는 재현되지 않는다 — CI 의 type-check 단계는 DS 체크아웃 **전**이라 게시본을 본다.
//   처방 방향: 쓰는 prop 만 손으로 선언하거나(현 사용처는 prefix·value·onChange 뿐),
//     pbo-core 가 prop 타입을 재수출하게 한다. 둘 다 별도 작업이다.
import { Icon as DsIcon } from '@musinsa/pbo-assets'
// 달력은 **antd 글리프**다. DS 아이콘 가이드(Storybook "PBO Core/guide/icons", #230 2026-07-22)가
//  출처를 "아이콘이 무엇을 가리키는가"로 가르는데, 날짜 선택은 **UI 행위**(화면 조작 보조)지 업무 개체가 아니다.
//  → UI 행위·방향·상태 = @ant-design/icons / 업무 개체·도메인 시맨틱 = @musinsa/pbo-assets 도메인 서브패스.
//  짝이 되는 core.DatePicker 접미 아이콘도 CalendarOutlined 라 한 화면 안에서 글리프가 맞는다. CLAUDE.md ①-1.
import { CalendarOutlined } from '@ant-design/icons'
import {
  ALLOC_TARGETS, CAPA_RISK_PCT, CENTERS, DOW7, HOURS_ORD, SCEN_ANTD_COLOR, WAIT_MAX, activeScenPrioFor, addDays, dKey, dayVals, excKey, fmtMD, fmtWait, fmtYmd, isCenterActive,
  isAllocStore, isoWeek, orderFor, parseYmd, rankedFor, relMin, sameDay, scenOf, scenWithin, waitFor, weekStart,
  type CellVals, type ChgSrc, type DispatchState, type DispatchUnit, type Scenario,
} from './dispatchShared'
import './dispatchParts.css'

const { Alert, Button, DatePicker, FormItem, InputNumber, Progress, Select, Spin, Table, Tag, TimePicker, Tooltip } = core

// ── TimeField — 시각 입력(HH:mm). 컨덕터 소유 이식본(2026-09-10 ⑤ 1-D, 문서 42 §3).
//    종전엔 DS `components-desktop/time-field` 요소였다. 출고일정관리 모달 1화면만 쓰는 **값 계약 어댑터**
//    (antd TimePicker 는 Dayjs 를 주고받지만 소비처는 문자열 'HH:mm' 로 저장·비교)라 DS 요소가 아니다 —
//    사용자 확정 2026-09-10 "전부 전환". 시각·prop(minuteStep 1 · showNow/needConfirm 끔 · prefix)은 DS 원본 그대로.
//    ⚠️ '24:00' 은 Dayjs 로 표현할 수 없다 — 소비처가 `value === '24:00' ? '00:00' : value` 로 바꿔 넘긴다.
const TIME_FORMAT = 'HH:mm'
// ⚠️ antd 의 TimePickerProps 를 **상속하지 않는다**(2026-09-16 처방 실행 — 위 주석의 '쓰는 prop 만 손으로 선언').
//   상속하면 `...rest` 가 **소비처 antd 타입 전면**(6.5.0, prop 359개)이 되는데, 런타임 TimePicker 는
//   core→antd 5 라 그 객체가 `Omit<TimePickerProps,'ref'>` 에 대입되지 않는다(TS2322).
//   실측 2026-09-16 mwms-fe 핸드오프: 이 한 건이 MWMS 배포를 막는 유일한 타입 에러였다.
//   ⛔ 반대 방향(core 파생 `ComponentProps<typeof TimePicker>`)은 안 된다 — 선언 출력이 pnpm 트리 깊은
//     이름을 참조해 CI 의 `tsc -b` 가 TS2742/TS4023 으로 깨진다(2026-09-15 base 실측).
//   실제 사용처는 5개뿐이다(value·onChange·prefix·style·disabled) — 전수 확인하고 그대로 적었다.
export interface TimeFieldProps {
  /** 'HH:mm'. 빈 문자열/undefined 면 비어 있는 상태. */
  value?: string
  /** 값이 바뀔 때 'HH:mm' 로 받는다. 지우면 빈 문자열. */
  onChange?: (value: string) => void
  /** 입력 앞 라벨(예: '당일'·'익일'). */
  prefix?: ReactNode
  /** 폭 등 — 사용처가 주는 것만(전면 상속 금지). */
  style?: CSSProperties
  disabled?: boolean
  /** 상한 'HH:mm' — 이 시각 **뒤는 고를 수 없다**(비활성 시·분). 일괄 출고가 '출고 종료' 뒤로 못 가게
   *  하는 데 쓴다(LUA 확정 2026-09-29 "종료보다 늦은시간은 아예 선택 불가"). 경고가 아니라 입력 차단이다 —
   *  고른 뒤 막으면 왜 안 되는지 다시 배워야 하고, 저장까지 가면 모순된 설정이 남는다. */
  notAfter?: string
  /** 지우기(✕) 버튼 — 필수 값은 끈다. 지울 수 있게 두면 '비운 채 저장'이라는 상태가 생기는데,
   *  모달 [확인]은 닫힘이 먼저라(core.Modal 계약) 막는 순간 편집하던 값이 사라진다.
   *  애초에 비울 수 없게 하는 쪽이 사용자 손해가 없다(2026-09-29 실측). 기본은 antd 기본값(지우기 가능). */
  allowClear?: boolean
  /** 오류 표시 — 값이 규칙을 어긴 행을 빨간 테두리로 세운다(어느 행이 문제인지 목록에서 바로 보이게). */
  status?: 'error'
}
const toDayjs = (v?: string): Dayjs | null => {
  if (!v) return null
  const d = dayjs(v, TIME_FORMAT, true)
  return d.isValid() ? d : null
}
const span = (n: number) => Array.from({ length: n }, (_, i) => i)
export function TimeField({ value, onChange, prefix, notAfter, ...rest }: TimeFieldProps) {
  const lim = notAfter ? relMin(notAfter) : null
  // 상한 = 보이는 시계 순서(relMin). 시는 '그 시의 첫 분(=h*60)'이 상한을 넘으면 통째로 막는다.
  const disabledTime = lim == null ? undefined : () => ({
    disabledHours: () => span(24).filter((h) => h * 60 > lim),
    disabledMinutes: (h: number) => span(60).filter((m) => h * 60 + m > lim),
  })
  return (
    <TimePicker
      {...rest}
      disabledTime={disabledTime}
      prefix={prefix}
      value={toDayjs(value)}
      format={TIME_FORMAT}
      // 분 단위 자유 입력 — 출고 마감 시각은 10분 단위가 아닌 값(예: 22:30·23:50)이 실제로 쓰인다.
      minuteStep={1}
      // 초는 쓰지 않는다(저장 포맷이 HH:mm).
      showNow={false}
      needConfirm={false}
      onChange={(d) => onChange?.(d ? d.format(TIME_FORMAT) : '')}
    />
  )
}

// ── MetricCard — 원본 mwms/MetricCard.tsx 1:1(운영 카드가 소비) ──────────────────────────────────────────────
export interface MetricItem {
  label?: string // 없으면 값만 우측 정렬(와이어프레임 '오늘 도착예정' 유형)
  value: number | string
  unit?: string // ML · PCS · 명 등 12px 보조 표기
}
export interface MetricCardProps {
  title: ReactNode // 문자열 기본. 운영명 Tag 등 노드도 허용(출고일정관리 운영 카드형)
  info?: string // ⓘ 툴팁 — 지표 산식·집계 기준 등 보조 설명
  progress?: number // 우상단 진행률/달성률(%)
  extra?: ReactNode // 우상단 커스텀(상태 Tag 등) — antd Card 의 extra 와 동일 어휘. progress 와 함께면 progress 왼쪽
  description?: ReactNode // 타이틀 아래 서브 디스크립션(12px 보조색) — 기간·범위 등 부가 정보
  metrics?: MetricItem[] // 첫 항목 = 주 지표(24px), 이후 = 보조 지표(16px)
  breakdown?: MetricItem[] // 구분선 아래 12px 상세 목록(단수단포/복수단포/합포 등)
  actions?: ReactNode // 하단 액션 버튼 영역 — 평소 숨김, hover/포커스 시 노출(밀도 유지). 공간은 항상 확보(레이아웃 점프 방지)
  selected?: boolean
  disabled?: boolean
  onClick?: () => void // 있으면 클릭형(필터 카드) — hover·포커스 제공
  children?: ReactNode // 확장 슬롯(특수 콘텐츠) — 기본 미사용
}
const fmtMetric = (v: number | string) => (typeof v === 'number' ? v.toLocaleString() : v)
function MetricRow({ item, valueClass }: { item: MetricItem; valueClass: string }) {
  return (
    <div className="mc-row">
      {item.label != null && <span className="mc-label">{item.label}</span>}
      <span className={valueClass}>
        {fmtMetric(item.value)}
        {item.unit && <em className="mc-unit">{item.unit}</em>}
      </span>
    </div>
  )
}
export function MetricCard({ title, info, progress, extra, description, metrics = [], breakdown, actions, selected, disabled, onClick, children }: MetricCardProps) {
  // 타이틀형: 지표가 없는 카드는 타이틀이 주인공(20px) — '유형은 콘텐츠가 결정' 원칙(운영 카드 등 명칭+설명 카드).
  const titular = metrics.length === 0 && !(breakdown && breakdown.length > 0)
  const clickable = !!onClick && !disabled
  const cls = ['lg-metric-card', titular ? 'is-titular' : '', selected ? 'is-selected' : '', disabled ? 'is-disabled' : '', clickable ? 'is-clickable' : '']
    .filter(Boolean)
    .join(' ')
  return (
    <div
      className={cls}
      {...(clickable ? { role: 'button', tabIndex: 0, 'aria-pressed': !!selected } : {})}
      aria-disabled={disabled || undefined}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.() } } : undefined}
    >
      <div className="mc-head">
        <span className="mc-title">{title}</span>
        {info && (
          <Tooltip title={info}>
            <span className="mc-info" style={{ display: 'inline-flex', lineHeight: 0 }}><DsIcon name="ic-infoCircle" size={14} color="currentColor" /></span>
          </Tooltip>
        )}
        {(progress != null || extra != null) && (
          <span className="mc-head-right">
            {progress != null && <span className="mc-progress">{progress}%</span>}
            {extra}
          </span>
        )}
      </div>
      {description != null && <div className="mc-desc">{description}</div>}
      {metrics.length > 0 && (
        <div className="mc-metrics">
          {metrics.map((m, i) => (
            <MetricRow key={i} item={m} valueClass={i === 0 ? 'mc-val mc-val-main' : 'mc-val mc-val-sub'} />
          ))}
        </div>
      )}
      {breakdown && breakdown.length > 0 && (
        <>
          <div className="mc-divider" />
          <div className="mc-breakdown">
            {breakdown.map((b, i) => (
              <MetricRow key={i} item={b} valueClass="mc-val mc-val-xs" />
            ))}
          </div>
        </>
      )}
      {children}
      {actions != null && !disabled && <div className="mc-actions">{actions}</div>}
    </div>
  )
}

// ── 운영 카드 영역 — 화면 트리로 펼침(LUA 확정 2026-09-14 ①) ─────────────────────────────────────────────
//   구 core.DispatchScenarioCards(통짜 시임) 해체. 래퍼 .sc-cards(core.Flex)와 [운영 추가](core.Button)는
//   출고일정 **화면 트리 노드**로 나갔다 — 여기 남는 건 정적 트리로 못 펴는 두 조각뿐:
//     · BaseOpsCard       = 기본 운영 카드. '운영중' 딱지가 오늘 날짜 x 시나리오 기간에서 파생된다.
//     · ScenarioCardList  = 시나리오 카드 N개(데이터 반복). 래퍼는 display:contents(.sc-list) —
//       카드가 부모 flex(.sc-cards)의 직접 항목으로 남아 원본과 같은 줄바꿈·stretch 를 그린다.
export interface BaseOpsCardProps {
  scenarios: Scenario[]
  today: Date
  onEditBase: () => void
}
export function BaseOpsCard({ scenarios, today, onEditBase }: BaseOpsCardProps) {
  // 오늘의 운영중은 항상 정확히 1개(하루 1개 규칙) — 시나리오가 없는 날은 기본 운영이 운영중
  const anyLive = scenarios.some((s) => scenWithin(s, today))
  return (
    <div className="scen-card base-card">
      {/* 운영중 = 딱지만 — 지표 카드의 selected(파란 보더)는 '선택' 문법이라 상태 표시에 쓰지 않음(LUA) */}
      {/* 딱지 색 = 그 운영의 색. 시나리오 카드는 자기 색(SCEN_ANTD_COLOR)을 쓰는데 기본 운영만
          기본 회색이라 "지금 돌고 있다"로 안 읽혔다(LUA 2026-09-15). 기본 운영엔 배정된 색이 없으므로
          **프라이머리**(antd processing — colorPrimary 토큰에 묶인 상태 프리셋)를 쓴다.
          preset 'blue'(추석 시나리오 색)와 겹쳐 보이지만 운영중은 하루에 정확히 1개라 동시에 뜨지 않는다. */}
      <MetricCard
        title="기본 운영"
        description="상시"
        extra={!anyLive ? <Tag color="processing">운영중</Tag> : undefined}
        actions={<Button size="small" onClick={onEditBase}>수정</Button>}
      />
    </div>
  )
}

export interface ScenarioCardListProps {
  scenarios: Scenario[]
  today: Date
  onEditScen: (id: string) => void
  onJumpPeriod: (from: string) => void
}
export function ScenarioCardList({ scenarios, today, onEditScen, onJumpPeriod }: ScenarioCardListProps) {
  // 카드 줄에는 **운영중·예정만** 선다 — 끝난 운영은 사라진다(LUA 2026-09-15 도메인 규칙).
  //  그래서 딱지가 없는 카드 = 전부 '예정'이다(종료와 섞이지 않아 딱지 없음이 한 가지 뜻만 갖는다).
  //  그리드는 이 필터를 쓰지 않는다 — 지난 주로 이동하면 그때 적용됐던 운영 색이 그대로 보여야 한다.
  const todayYmd = fmtYmd(today)
  const sorted = scenarios
    .filter((s) => s.to >= todayYmd)
    .sort((a, b) => a.from.localeCompare(b.from))
  return (
    <div className="sc-list">
      {sorted.map((s) => {
        const live = scenWithin(s, today)
        return (
          <div key={s.id} className="scen-card" data-sc={s.color} title={s.full}>
            <MetricCard
              title={s.name}
              extra={live ? <Tag color={SCEN_ANTD_COLOR[s.color]}>운영중</Tag> : undefined}
              description={`${fmtMD(parseYmd(s.from))} ~ ${fmtMD(parseYmd(s.to))}`}
              actions={
                <>
                  <Button size="small" onClick={() => onEditScen(s.id)}>수정</Button>
                  {/* 기간 이동 = 내비게이션(상태 변경 없음) — 수정(주 액션)보다 한 단계 낮은 텍스트 버튼(LUA) */}
                  <Button size="small" type="text" onClick={() => onJumpPeriod(s.from)}>기간 이동</Button>
                </>
              }
            />
          </div>
        )
      })}
    </div>
  )
}

// ── 날짜 내비 라벨+피커(시임) — 원본 DateNav 의 .wkpick 부분 + Tag/Alert 슬롯. [오늘] ‹ › 는 트리 core.Button ────
//   래퍼는 display:contents — 원본처럼 spacer(flex:1)·Alert 가 툴바 행(core.Flex)의 직접 항목으로 늘어난다.
export interface DispatchDateLabelProps {
  view: 'week' | 'day'
  state: DispatchState
  today: Date
  /** week — 주(week) 창 오프셋 */
  winOffset: number
  onWinOffset: (w: number) => void
  /** day — 일 오프셋 */
  dayOffset: number
  onDayOffset: (n: number) => void
}
export function DispatchDateLabel({ view, state, today, winOffset, onWinOffset, dayOffset, onDayOffset }: DispatchDateLabelProps) {
  const [open, setOpen] = useState(false)
  if (view === 'week') {
    const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart(today), winOffset * 7 + i))
    const jumpToWeek = (d: Date) => onWinOffset(Math.round((weekStart(d).getTime() - weekStart(today).getTime()) / (7 * 86400000)))
    return (
      <span className="dnlabel">
        <span className="wkpick" onClick={() => setOpen(true)}>
          <span className="wklbl">W{isoWeek(days[0]!)}</span>
          <span className="rangelbl">{fmtYmd(days[0]!)} ~ {fmtMD2(days[6]!)}</span>
          <Button size="small" type="text" aria-label="주 선택" icon={<CalendarOutlined />} />
          <DatePicker picker="week" className="wkpick-input" open={open} onOpenChange={setOpen} value={dayjs(days[0]!)} showNow={false}
            onChange={(v) => { if (v) { jumpToWeek(v.toDate()); setOpen(false) } }} />
        </span>
        {/* 보기 필터를 날짜 내비 최우측으로 미는 여백(LUA) — 원본 DateNav 의 .spacer 그대로.
            래퍼가 display:contents 라 이 div 는 툴바 행(core.Flex)의 직접 항목으로 늘어난다(일 뷰 Alert 과 같은 방식). */}
        <div className="spacer" />
      </span>
    )
  }
  const d = addDays(today, dayOffset)
  const isToday = sameDay(d, today)
  const isFutureDay = !isToday && d > today // 미래: 열 클릭(편집 진입) 자체를 막고 상단 배너로 안내(LUA)
  const sc = scenOf(state.scenarios, d)
  return (
    <span className="dnlabel">
      <span className="wkpick" onClick={() => setOpen(true)}>
        <span className="wklbl">{fmtYmd(d)} ({DOW7[d.getDay()]}){isToday ? <em className="today-em"> 오늘</em> : null}</span>
        <Button size="small" type="text" aria-label="날짜 선택" icon={<CalendarOutlined />} />
        <DatePicker className="wkpick-input" open={open} onOpenChange={setOpen} value={dayjs(d)} showNow={false}
          onChange={(v) => { if (v) { onDayOffset(Math.round((v.startOf('day').toDate().getTime() - today.getTime()) / 86400000)); setOpen(false) } }} />
      </span>
      {sc ? <Tag color={SCEN_ANTD_COLOR[sc.color]}>임시 · {sc.name}</Tag> : <Tag>기본</Tag>}
      {/* 여백 — **항상** 낸다(주 뷰와 같게). 종전엔 미래 날짜 안내가 있을 때만 냈는데, 그 뒤로 툴바 최우측에
          최근 업데이트·새로고침이 붙으면서(2026-09-16) 오늘/과거에는 그것들이 날짜 옆에 붙어 버렸다.
          래퍼가 display:contents 라 이 div 는 툴바 행(core.Flex)의 직접 항목으로 늘어난다. */}
      <div className="spacer" />
      {/* 미래 날짜 = 조회 전용 — 클릭 차단 대신 이유를 상시 안내(테이블 우측 상단, LUA). 문구는 규칙 한 문장만(2026-10-15 — '운영을 변경하세요' 후행 문장 삭제) */}
      {isFutureDay && <Alert type="info" showIcon message="우선순위 예외는 당일만 등록할 수 있습니다." />}
    </span>
  )
}
const pad2 = (n: number) => String(n).padStart(2, '0')
const fmtMD2 = (d: Date) => `${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`

// ── 소진/가동 바 — 원본 CapaBar 1:1 ────────────────────────────────────────────────────────────────────────
export function CapaBar({ pct, unl }: { pct: number; unl: boolean }) {
  const over = pct > 100
  const hot = pct >= 90 && !unl
  return (
    <Progress
      percent={Math.min(pct, 100)}
      showInfo={false}
      size={['100%', 4]}
      status={over && !unl ? 'exception' : 'normal'}
      strokeColor={over && unl ? '#722ed1' /* Base-Purple-6 */ : hot ? '#faad14' /* Gold-6 */ : undefined}
    />
  )
}

// ── 센터 운영 그리드(표 본문) — 원본 DispatchOpsGrid 에서 DateNav 를 뺀 부분 1:1 ───────────────────────────
function Line({ lb, vl, src }: { lb: string; vl: string | string[]; src?: ChgSrc }) {
  // 기본 대비 증감 화살표 제거(LUA 07-13): 변경 출처는 헤더 운영 Tag·셀 틴트·볼드 강조로 충분
  const base = src === '시나리오' ? 'ln chg-sc' : src === '당일예외' ? 'ln chg-ex' : 'ln'
  // 값이 여럿이면 **세로로 쌓는다**(LUA 확정 2026-09-18 — 일괄 출고 2개 이상). 가로로 이으면
  //  `22:00 · 24:00` 처럼 한 덩어리로 읽혀 몇 번 내보내는지가 한눈에 안 들어온다. 세로면 줄 수가 곧 횟수다.
  //  라벨은 첫 값과 눈높이를 맞춘다(ln.multi → align-items flex-start).
  const many = Array.isArray(vl) && vl.length > 1
  return (
    <div className={many ? `${base} multi` : base}>
      <span className="lb">{lb}</span>
      {Array.isArray(vl)
        ? <span className="vl stack">{vl.map((t) => <span key={t}>{t}</span>)}</span>
        : <span className="vl">{vl}</span>}
    </div>
  )
}
function CellBody({ v, capaOnly, showEndAt }: { v: CellVals; capaOnly?: boolean; showEndAt?: boolean }) {
  const unl = v.capaMode === 'unlimited'
  if (v.off) return <div className="cell-body"><div className="cell-off">— 휴무 —</div></div>
  let capaBlock: ReactNode = null
  const dircls = v.chg.capa === '당일예외' ? 'cap-ex' : v.chg.capa ? 'cap-sc' : ''
  if (v.orders != null) {
    // 과거=확정 실적, 오늘=라이브 — 지시량 / 케파 (소진율). '처리'→'지시'(LUA, 출고지시 도메인 용어)
    const over = (v.orderPct ?? 0) > 100
    capaBlock = (
      <div className={`capa-hero ${dircls}`}>
        {/* ∞ = 라벨 우측 아이콘(무한 케파 표식) — Tag 는 과함(LUA). '목표' 표현 대신 케파로 통일 */}
        <div className="capa-top"><span className="capa-lb">지시 / 캐파</span>{unl && <span className="capa-inf">∞</span>}</div>
        <div className="capa-val">
          <b>{v.orders.toLocaleString()}</b>
          <span className="capa-cap">/ {v.capa.toLocaleString()}</span>
          <span className={over ? (unl ? 'capa-pct over-ok' : 'capa-pct over-stop') : 'capa-pct'}>
            {/* 제한 모드 한도초과 = **'100%'**(빨강 over-stop). '마감' 을 붙이지 않는 이유(LUA 2026-09-15):
                '마감' 이 케파가 마감됐다는 뜻으로도 읽혀 의미가 애매하다. 또 제한 모드에서는 100% 에서
                출고지시가 멈추므로 실제 소진율은 100% 를 넘지 않는다 — 100% 가 잘라낸 값이 아니라 정확한 값이다.
                중단 신호는 색(빨강)과 꽉 찬 바가 갖는다. 문구를 늘리면 셀 최소 폭이 170 → 194 로 뛴다(실측). */}
            {over ? (unl ? `${v.orderPct}%` : '100%') : `${v.orderPct}%`}
          </span>
        </div>
        <CapaBar pct={v.orderPct ?? 0} unl={unl} />
      </div>
    )
  } else {
    const over = v.util != null && v.util > 100
    capaBlock = (
      <div className={`capa-hero ${dircls}`}>
        <div className="capa-top"><span className="capa-lb">출고 캐파</span>{unl && <span className="capa-inf">∞</span>}</div>
        <div className="capa-val">
          <b>{v.capa.toLocaleString()}</b>
          {v.util != null && (
            <span className={over ? (unl ? 'capa-pct over-ok' : 'capa-pct over-stop') : 'capa-pct'}>
              {/* 위와 같은 규칙 — 제한 모드 한도초과는 '100%' 빨강(LUA 2026-09-15). */}
              {over ? (unl ? `${v.util}%` : '100%') : `${v.util}%`}
            </span>
          )}
        </div>
        {v.util != null && <CapaBar pct={v.util} unl={unl} />}
      </div>
    )
  }
  return (
    <div className="cell-body">
      {capaBlock}
      {/* 케파 중심뷰(LUA) — '케파만 보기' 시 출고시작·마감 라인을 접어 케파에 집중(밀도↑, 센터 비교 빠름) */}
      {!capaOnly && (
        <div className="time-sub">
          {/* 표기는 모달 폼 라벨과 같게(LUA 2026-09-15) — 라벨 폭 41 → 45, 행 폭 116 이라 여유 있다(실측) */}
          <Line lb="출고 시작" vl={v.start} src={v.chg.start} />
          {/* 출고 종료 — 스토어 단위에서만 선다(LUA 2026-09-29). 값이 없으면 '없음'이라 말한다:
              빈칸은 '설정 안 함'과 '종료 없이 계속 받음'을 구분하지 못한다(일괄 출고와 같은 규칙). */}
          {showEndAt && <Line lb="출고 종료" vl={v.endAt || '없음'} src={v.chg.endAt} />}
          {/* 라벨 하나 + 시각을 **세로로** 쌓는다(LUA 확정 2026-09-18). 라벨을 행마다 반복하지 않으므로
              줄이 늘어도 지저분해지지 않고, 줄 수가 곧 '하루 몇 번 내보내는가' 가 된다.
              빈 목록은 '없음' 이라 말한다 — 빈칸은 '설정 안 함' 과 구분이 안 된다. */}
          <Line lb="일괄 출고" vl={v.releases.length ? v.releases : '없음'} src={v.chg.releases} />
        </div>
      )}
    </div>
  )
}
export interface OpsGridProps {
  state: DispatchState
  today: Date
  onCell: (ci: number, d: Date) => void
  winOffset: number // 주(week) 단위 창 오프셋(0=이번 주) — 부모 소유(운영 카드 '기간 이동'이 제어)
  /** 케파 중심뷰 — 셀에서 출고시작·마감 라인을 접는다. 툴바의 '케파만 보기' 토글(트리 core.Switch)이 소유.
   *  뷰 전용 상태(운영 데이터 무영향)라 dispatchStore 가 아니라 상호작용 스토어를 쓴다. */
  capaOnly?: boolean
  /** 행(거점) 목록 — 관리 단위(센터·스토어·글로벌센터)가 정한다(2026-09-11). 미지정이면 센터. */
  centers?: [string, string][]
  /** 다시 받아오는 중 — 툴바 [새로고침]을 누른 결과가 **표 위에** 보여야 사용자가 눌린 것을 안다(LUA 2026-09-16). */
  loading?: boolean
  /** 셀에 '출고 종료' 줄을 세운다 — 스토어 단위 전용 값이라 단위가 정한다(2026-09-29). */
  showEndAt?: boolean
  /** 첫 열 머리글 — 행 목록(centers)과 같은 단위 이름(센터·스토어·글로벌센터). 스토어 단위에서도 '센터'로 나오던 것(LUA QA 2026-10-13). 미지정이면 센터. */
  unitLabel?: string
}
export function OpsGrid({ state, today, onCell, winOffset, capaOnly, centers = CENTERS, loading, showEndAt, unitLabel = '센터' }: OpsGridProps) {
  // 위크 단위 창(LUA) — 월요일 시작 캘린더 주. 오늘은 요일에 따라 주 중간에 위치.
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart(today), winOffset * 7 + i))
  const isPastDay = (d: Date) => !sameDay(d, today) && d < today
  // 호버 십자 가이드 — 할당 우선순위 표와 동일 문법(LUA): 같은 행·열 하이라이트, 리렌더 대신 클래스 토글(성능)
  const tblRef = useRef<HTMLTableElement>(null)
  const clearXhl = () => tblRef.current?.querySelectorAll('.xhl, .xhl-o').forEach((el) => el.classList.remove('xhl', 'xhl-o'))
  const onCross = (e: React.MouseEvent) => {
    const tbl = tblRef.current
    const cell = (e.target as HTMLElement).closest('td.day, thead th') as HTMLTableCellElement | null
    if (!tbl || !cell) { clearXhl(); return }
    if (cell.classList.contains('xhl-o')) return // 같은 셀 내 이동 — 재계산 생략
    clearXhl()
    cell.classList.add('xhl-o')
    const col = cell.cellIndex
    tbl.querySelectorAll(`tr > *:nth-child(${col + 1})`).forEach((el) => el.classList.add('xhl'))
    if (cell.tagName === 'TD') cell.parentElement?.querySelectorAll('td').forEach((el) => el.classList.add('xhl'))
  }
  return (
    <Spin spinning={!!loading}>
    <div className="gwrap">
      <table className="sched" ref={tblRef} onMouseOver={onCross} onMouseLeave={clearXhl}>
        <thead>
          <tr>
            <th className="cnh">{unitLabel}</th>
            {days.map((d, di) => {
              const sc = scenOf(state.scenarios, d)
              return (
                <th key={di} className={sameDay(d, today) ? 'today' : isPastDay(d) ? 'is-past' : ''} data-sc={sc?.color}>
                  {/* 시나리오는 날짜 단위(하루 1개) → 셀 배지 대신 헤더에 Tag 로 표기 */}
                  <div className="colh">
                    <span className="dt">{fmtMD(d)}({DOW7[d.getDay()]}){sameDay(d, today) ? ' 오늘' : ''}</span>
                    {/* 운영명이 길면 말줄임(.colh .ant-tag) — 전체 이름은 hover 로 읽는다(mwms-fe #1527 리뷰 반영, 2026-10-13) */}
                    {sc && <Tag color={SCEN_ANTD_COLOR[sc.color]} title={sc.name}>{sc.name}</Tag>}
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {/* 미사용 센터는 줄 자체가 없다(2026-09-16 LUA) — 안 쓰는 센터가 표에 남아 있으면 케파·마감이
              계속 눈에 들어와 관리 대상처럼 읽힌다. ⚠️ **필터링이 아니라 건너뛰기**다: ci 는 센터 배열의
              위치이고 예외·운영값이 전부 그 번호로 매인다. 배열을 걸러내면 번호가 밀려 다른 센터의 값이
              딸려온다 — 순회는 전부 돌고 그리지 않을 줄만 null 을 낸다. */}
          {centers.map((c, ci) => (!isCenterActive(state, ci) ? null : (
            <tr key={c[1]}>
              {/* 센터 코드(YJU-01 등)는 **실존하지 않는 값**이라 화면에서 뺀다(LUA 2026-09-15).
                  데이터의 c[1] 은 목 식별자로만 남는다(React key·상태 키) — 사용자에게 보이지 않는다. */}
              <td className="cn">{c[0]}</td>
              {days.map((d, di) => {
                const st = scenOf(state.scenarios, d)
                const v = dayVals(state, today, d, ci)
                const hasExc = !!state.todayExc[excKey(ci, d)]
                return (
                  <td
                    key={di}
                    className={`day ${sameDay(d, today) ? 'today' : ''} ${hasExc ? 'has-exc' : ''} ${isPastDay(d) ? 'is-past' : ''}`}
                    data-sc={st?.color}
                    onClick={() => onCell(ci, d)}
                  >
                    {hasExc && <Tag color="red" className="exc-tag">예외</Tag>}
                    <CellBody v={v} capaOnly={capaOnly} showEndAt={showEndAt} />
                  </td>
                )
              })}
            </tr>
          )))}
        </tbody>
      </table>
    </div>
    </Spin>
  )
}

// ── 할당 우선순위 표(본문) — 원본 DispatchPriority 에서 DateNav 를 뺀 부분 1:1 ──────────────────────────────
const pad = (n: number) => String(n).padStart(2, '0')
/** 지금 시간대 셀의 케파 상태 — 할당이 실제로 가고 있는 자리에서만 본다(LUA 2026-09-16).
 *  케파·가동률은 **일 단위** 축이다(dayVals 에 시간 인자가 없다 — 출고일정관리도 같다). 그래서 신호는
 *  '오늘 이 센터가 얼마나 찼나' + '지금이 몇 시냐' 의 조합이다: 오늘 거의 찼으면 지금부터 순위를 내린다.
 *
 *  세 상태를 **문구로** 가른다 — '아직 받는 중' 과 '이미 멈춘 것' 은 사용자에게 전혀 다른 사실이다:
 *   · 임박  = 임계 초과, 아직 받는 중
 *   · 초과  = 무한 케파가 100% 를 넘겨 계속 받는 중
 *   · 마감  = 제한 케파가 100% 도달 — 그 지점에서 출고지시가 멈춘다(케파 셀 주석, LUA 2026-09-15)
 *  문구는 **상태만** 말한다 — '순위를 내리세요' 같은 조치 권유는 두지 않는다(LUA 2026-09-16).
 *   무엇을 할지는 사용자가 정한다. 화면은 판단 재료만 댄다.
 *  100% 는 임계값이 아니라 **케파 정의상의 경계**(제한 모드가 멈추는 지점)라 CAPA_RISK_PCT 와 무관하다 —
 *  개발이 위험 구간을 내려줘도 이 경계는 그대로다.
 */
export interface CapaNow {
  // LOGISPRD-14424: capa null = 숫자 케파 없음(실 모드 UNLIMITED·LIMITED available 없음). 데모 capaNow 는 항상 숫자다.
  off: boolean; unl: boolean; capa: number | null; orders: number | null; pct: number | null
  risk: { label: string; tone: 'gold' | 'red' } | null
  note: string
}
export function capaNow(state: DispatchState, today: Date, d: Date, ci: number): CapaNow {
  const v = dayVals(state, today, d, ci)
  const unl = v.capaMode === 'unlimited'
  const base = { off: !!v.off, unl, capa: v.capa, orders: v.orders ?? null, pct: v.orderPct ?? v.util ?? null }
  if (v.off) return { ...base, risk: null, note: '휴무' }
  const pct = base.pct
  if (pct == null) return { ...base, risk: null, note: '가동률 집계 전' }
  // 제한 모드는 100% 에서 지시가 멈춘다 — 표시값도 100% 로 자르는 케파 셀과 같은 규칙.
  if (!unl && pct >= 100) return { ...base, pct: 100, risk: { label: '마감', tone: 'red' }, note: '출고지시 중단' }
  if (unl && pct > 100) return { ...base, risk: { label: '초과', tone: 'red' }, note: '초과 가동 중' }
  if (pct > CAPA_RISK_PCT) return { ...base, risk: { label: '임박', tone: 'gold' }, note: '캐파 임박' }
  return { ...base, risk: null, note: '여유' }
}
/** 지금 열 셀의 호버 — 케파 상태를 출고일정관리와 **같은 어휘**로 보여준다(지시 / 캐파 · ∞ · 소진율).
 *  위험한 칸에만 달면 '왜 어떤 칸은 안 뜨지' 가 되므로 지금 열 13칸 전부에 단다 — 여유도 순위 판단 재료다. */
function CapaTip({ name, c }: { name: string; c: CapaNow }) {
  return (
    <div className="capa-tip">
      {/* 어휘는 값을 **고치는 컨트롤**을 따른다 — 기본 운영 설정·당일 예외의 세그먼트가 '제한 / 무한' 이라
          툴팁만 '무제한' 이면 같은 값이 두 이름을 갖는다(2026-09-17 예외 창에 세그먼트를 넣으며 정리). */}
      <div className="ct-nm">{name}<span className="ct-mode">{c.unl ? '무한' : '제한'}</span></div>
      {!c.off && (
        <div className="ct-val">
          {c.capa == null
            ? <>{c.orders != null && `지시 ${c.orders.toLocaleString()} / `}캐파 {c.unl ? '∞' : '—'}</>
            : <>지시 {c.orders != null ? c.orders.toLocaleString() : '—'} / 캐파 {c.capa.toLocaleString()}{c.unl && ' ∞'}</>}
        </div>
      )}
      {/* LOGISPRD-14579 R7: note 가 비면(실 모드) ' · ' 를 남기지 않는다. */}
      <div className="ct-note">{c.pct != null && !c.off ? [`${c.pct}%`, c.note].filter(Boolean).join(' · ') : c.note}</div>
    </div>
  )
}

export interface PriorityTableProps {
  /** 거점 목록 — 관리 단위가 정한다(2026-09-14). 미지정이면 센터. */
  centers?: [string, string][]
  state: DispatchState
  today: Date
  nowHour: number
  // 선택 상태(날짜·시간대)는 컨테이너 소유(LUA 트리 정리) — 편집 모달이 별도 스키마 노드라 컨테이너를 거쳐 공유
  dayOffset: number
  onSelHour: (h: number | null) => void
  onSelWaitHour: (h: number | null) => void
  selHour: number | null
  selWaitHour: number | null
  /** 다시 받아오는 중 — 툴바 [새로고침]을 누른 결과가 **표 위에** 보여야 사용자가 눌린 것을 안다(LUA 2026-09-16). */
  loading?: boolean
  /** 관리 단위 — 순위 시드가 없을 때의 기본 순열 길이를 정한다(할당우선순위 = 센터+스토어 19). 미지정이면 센터. */
  unit?: DispatchUnit
  /** 센터 자동 배분(할당우선순위 — 2026-10-14 요구사항 변경): 센터는 출고 케파 잔여율로 시스템이 순위를 매기고
   *  운영자는 스토어만 수기로 매긴다. 센터 행들은 **한 줄로 묶어 안내 문구만** 보이고(개별 센터 미노출),
   *  스토어만 1위부터 줄 세운다. 'top'/'bottom' = 묶음 위치 — 국가별 출고 우선순위 KR 의 센터·스토어 순서를 따른다. */
  autoCenters?: 'top' | 'bottom'
  /** LOGISPRD-14424: 지금 열 케파 상태 — 주면 데모 capaNow 대신 이것을 쓴다(실 모드 GET /capacity). */
  capaOf?: (ci: number) => CapaNow | null
}
/** 센터 자동 배분 안내(표 묶음 행·순위 편집 목록 공통) — LUA 2026-10-14. */
// 센터 묶음 한 칸 = **이름(전체 센터 자동 할당) + 기준 설명** 두 요소(LUA 2026-10-15). 종전엔 설명 문장만 있어
//  '1위 = 센터' 가 아니라 공지 배너로 읽혔다(순위 표의 다른 줄은 전부 '몇 위 = 어느 거점' 문법).
//  이름이 대상·방식을 함께 말하므로 '자동' 태그는 두지 않고, 설명은 남은 정보(센터 간 순서 기준)만 말한다.
export const AUTO_CENTER_LABEL = '전체 센터 자동 할당'
export const AUTO_CENTER_MSG = '출고 캐파 잔여율이 높은 센터부터 할당됩니다'
/** 센터 묶음 표기 — 순위 표·편집 목록 공용(같은 말·같은 모양). */
export function AutoCenterLabel() {
  return (
    <>
      <span className="autolabel">{AUTO_CENTER_LABEL}</span>
      <span className="autodesc">{AUTO_CENTER_MSG}</span>
    </>
  )
}

export function PriorityTable({ state, today, nowHour, dayOffset, onSelHour, onSelWaitHour, selHour, selWaitHour, centers = CENTERS, loading, unit = 'center', autoCenters, capaOf }: PriorityTableProps) {
  // 진입/날짜 전환 시 스크롤 기준(LUA): 오늘이면 '지금' 컬럼이 가장 좌측(순위 라벨 옆)에 오도록, 다른 날짜는 운영일 시작(23시)부터
  const wrapRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // 페인트 이후 적용(rAF) — 탭 전환 직후 등 레이아웃 확정 전에 스크롤하면 되돌아가는 문제 방지.
    // 늦은 시간대는 남은 컬럼 폭이 뷰포트보다 좁아 '가장 좌측'까지 못 가고 최대 스크롤에서 멈춤(브라우저 클램프) — 의도된 동작.
    const id = requestAnimationFrame(() => {
      const wrap = wrapRef.current
      if (!wrap) return
      if (!isToday) { wrap.scrollLeft = 0; return }
      const nowTh = wrap.querySelector('th.nowcol') as HTMLElement | null
      const rkn = wrap.querySelector('th.rkn') as HTMLElement | null
      if (nowTh) wrap.scrollLeft = Math.max(0, nowTh.offsetLeft - (rkn?.offsetWidth ?? 0))
    })
    return () => cancelAnimationFrame(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dayOffset])
  // 센터 묶음 줄 가운데 정렬(LUA 2026-10-15) — 묶음 칸은 24열을 다 덮어(수천 px) 그 칸 기준 가운데면 화면 밖이다.
  //  **보이는 폭**(스크롤 박스 − 고정 순위 열)을 CSS 변수로 넘겨, 문구를 그 폭의 sticky 상자 안에서 가운데 둔다.
  useEffect(() => {
    const wrap = wrapRef.current
    if (!wrap || !autoCenters) return
    const sync = () => {
      const rkn = wrap.querySelector('th.rkn') as HTMLElement | null
      const rw = rkn?.offsetWidth ?? 0
      wrap.style.setProperty('--rk-rkn', `${rw}px`)
      wrap.style.setProperty('--rk-vis', `${Math.max(0, wrap.clientWidth - rw)}px`)
    }
    sync()
    const ro = new ResizeObserver(sync)
    ro.observe(wrap)
    return () => ro.disconnect()
  }, [autoCenters])
  // 호버 십자 가이드 — 셀 hover 시 같은 행·열 전체(축 라벨 포함) 하이라이트. 리렌더 대신 클래스 토글(성능).
  const tblRef = useRef<HTMLTableElement>(null)
  const clearXhl = () => tblRef.current?.querySelectorAll('.xhl, .xhl-o').forEach((el) => el.classList.remove('xhl', 'xhl-o'))
  const onCross = (e: React.MouseEvent) => {
    const tbl = tblRef.current
    const cell = (e.target as HTMLElement).closest('td.rkcell, thead th') as HTMLTableCellElement | null
    if (!tbl || !cell) { clearXhl(); return }
    if (cell.classList.contains('xhl-o')) return // 같은 셀 내 이동 — 재계산 생략
    clearXhl()
    cell.classList.add('xhl-o')
    const col = cell.cellIndex
    tbl.querySelectorAll(`tr > *:nth-child(${col + 1})`).forEach((el) => el.classList.add('xhl'))
    if (cell.tagName === 'TD') cell.parentElement?.querySelectorAll('td, .rkn').forEach((el) => el.classList.add('xhl'))
  }
  const d = addDays(today, dayOffset)
  const isToday = sameDay(d, today)
  const isPastDay = !isToday && d < today
  const isFutureDay = !isToday && d > today // 미래: 열 클릭(편집 진입) 자체를 막고 상단 배너로 안내(LUA)
  // 운영일 23시 시작 → 23시는 위치 -1 (00시보다 앞)
  const isPastHour = (hr: number) => {
    if (isPastDay) return true
    if (!isToday) return false
    const pos = hr === 23 ? -1 : hr
    const nowPos = nowHour === 23 ? -1 : nowHour
    return pos < nowPos
  }
  // 센터 자동 배분이면 표의 순위 행 = 스토어만(같은 시간대 순열에서 스토어의 상대 순서). 센터는 묶음 행 하나로.
  //  LOGISPRD-16563: 스토어를 골라내는 건 데모 거점 목록(ALLOC_TARGETS)일 때만이다. 실 모드는 넘어온 거점(서버 창고) 전체가 수기 순위 대상이다.
  const auto = !!autoCenters && unit === 'alloc'
  //  참조 비교다 — 데모는 생성본이 ALLOC_TARGETS 그 자체를 넘기고, 실 모드는 배선이 서버 창고로 새 배열을 만들어 넘기므로 false.
  const storesOnly = auto && centers === ALLOC_TARGETS
  const orders = HOURS_ORD.map((hr) => {
    const o = orderFor(state, d, hr, unit)
    return storesOnly ? o.filter((ci) => isAllocStore(ci)) : o
  })
  // LOGISPRD-14424: 시간별 순위 구간 길이. 없으면 전부 순위(targets 없는 경로). 어느 시간에서도 순위가 없는 행은 순위 칸을 '-' 로.
  //  LOGISPRD-16563: 묶음 행과 함께여도 순위 구간은 거점 행에만 적용된다 — '-' 판정은 거점 행 기준, 표시 순위만 묶음 몫(+1)을 더한다.
  const rankeds = HOURS_ORD.map((hr) => rankedFor(state, d, hr))
  const maxRanked = rankeds.some((r) => r === undefined) ? centers.length : Math.max(0, ...(rankeds as number[]))
  const rowCount = auto ? (orders[0]?.length ?? 0) : centers.length
  // 센터 묶음도 순위 한 칸을 차지한다(LUA 2026-10-14) — 'top' 이면 1위 = 센터, 스토어는 2위부터.
  const storeRankOffset = auto && autoCenters === 'top' ? 1 : 0
  const autoRow = auto ? (
    <tr className="autorow">
      <td className="rkn">{autoCenters === 'top' ? 1 : rowCount + 1}위</td>
      <td className="autocell" colSpan={HOURS_ORD.length}><span className="automsg"><AutoCenterLabel /></span></td>
    </tr>
  ) : null
  const editKey = (hr: number) => `${dKey(d)}|${hr}`
  return (
    <Spin spinning={!!loading}>
    <div className="prio-grid">
      <div className="panel">
        {/* 패널 타이틀 영역 제거(LUA) — 표 자체가 곧 내용, 편집 유도는 열 클릭 시 우측 패널 등장으로 충분 */}
        <div className="hmwrap" ref={wrapRef}>
          <table className={`rk${isFutureDay ? ' na' : ''}`} ref={tblRef} onMouseOver={onCross} onMouseLeave={clearXhl}>
            <thead>
              <tr>
                <th className="rkn">순위</th>
                {HOURS_ORD.map((hr, oi) => {
                  const sp = activeScenPrioFor(state, d, hr)
                  // 당일 수동 편집 = 예외(운영에 미반영). **순위든 출고대기시간이든** 이 시간대의 예외다 —
                  //  둘은 한 창에서 함께 등록하므로(2026-09-16 예외 등록 창 통합) 표기도 시간대 단위로 하나다.
                  //  종전엔 순위만 봐서, 출고대기시간만 바꾸면 열 머리에 아무 표시도 없었다(LUA 2026-09-16 발견).
                  const prioEdited = !!state.prioEdits[editKey(hr)]
                  const waitEdited = state.waitEdits[editKey(hr)] != null
                  const edited = prioEdited || waitEdited
                  const editedWhat = [prioEdited ? '순위' : null, waitEdited ? '출고대기시간' : null].filter(Boolean).join('·')
                  const now = isToday && hr === nowHour
                  return (
                    <th
                      key={hr}
                      className={`${hr === selHour ? 'colsel' : ''}${oi > 0 && hr === 0 ? ' dayb' : ''}${isPastHour(hr) ? ' is-past' : ''}${now ? ' nowcol' : ''}${sp ? ' scenprio' : ''}${edited ? ' exccol' : ''}`}
                      data-sc={sp?.color}
                      title={edited ? `당일 예외 ${editedWhat} 적용 중` : sp ? `${sp.name} 운영 순위 적용` : undefined}
                      onClick={() => { if (!isFutureDay) onSelHour(hr) }}
                    >
                      {now && <span className="now-tag">지금</span>}
                      {edited && <Tag color="red" className="prio-exc">예외</Tag>}
                      {pad(hr)}:00 ~ {pad((hr + 1) % 24)}:00
                    </th>
                  )
                })}
              </tr>
              {/* 출고대기시간 행(LUA) — 주문 접수 후 할당까지 대기. 순위와 같은 시간대 축이라 헤더 바로 아래 고정 행으로 */}
              <tr className="waittr">
                <th className="rkn">출고대기시간</th>
                {HOURS_ORD.map((hr, oi) => {
                  const w = waitFor(state, d, hr)
                  const wEdited = state.waitEdits[editKey(hr)] != null // 출고대기 당일 예외 — 순위와 동일한 red 틴트
                  return (
                    <th
                      key={hr}
                      className={`waitcell${hr === selWaitHour ? ' colsel' : ''}${oi > 0 && hr === 0 ? ' dayb' : ''}${isPastHour(hr) ? ' is-past' : ''}${isToday && hr === nowHour ? ' nowcol' : ''}${wEdited ? ' exccol' : ''}`}
                      title={wEdited ? '당일 예외 출고대기시간 적용 중' : undefined}
                      onClick={() => { if (!isFutureDay) onSelWaitHour(hr) }}
                    >
                      {fmtWait(w)}
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {autoCenters === 'top' ? autoRow : null}
              {Array.from({ length: rowCount }, (_, r) => r + 1).map((rank) => ( // 행 = 넘겨받은 거점 수(할당우선순위 = 센터+스토어 19). 종전 N(센터 13) 고정이라 스토어 6곳이 안 그려졌다(moms-fe #879 리뷰, 2026-10-02)
                <tr key={rank}>
                  <td className="rkn">{rank > maxRanked ? '-' : `${rank + storeRankOffset}위`}</td>
                  {HOURS_ORD.map((hr, oi) => {
                    const ci = orders[oi]![rank - 1]!
                    const now = isToday && hr === nowHour
                    const edited = !!state.prioEdits[editKey(hr)]
                    const unranked = rankeds[oi] !== undefined && rank > rankeds[oi]! // LOGISPRD-14424
                    // 케파 위험 표시는 **지금 시간대만**(LUA 2026-09-16) — 지난 시간은 이미 끝났고 앞 시간은
                    //  가동률이 아직 없다. 순위 제한 없이 전 순위를 본다(LUA) — 대신 임계를 넘은 센터에만 붙는다.
                    const cn = now ? (capaOf ? capaOf(ci) : capaNow(state, today, d, ci)) : null
                    // 딱지는 이름 **뒤**에 붙는 인라인 항목이다(우측 absolute 로 두면 긴 이름과 겹친다).
                    //  열 폭은 머리글('12:00 ~ 13:00' = 108px)이 정하므로 딱지를 넣어도 표는 넓어지지 않는다(실측).
                    // 신호 형태 이력: 점 → 딱지 → 면 → 빨간 글자+주의 아이콘 → **빨간 글자 + 점**(2026-09-17).
                    //  딱지는 24열 표에서 지저분했고, 면(Red-1)은 지금 열의 파란 면을 덮고 예외 열(.exccol,
                    //  같은 Red-1)과 구분이 안 됐다. 주의 아이콘은 반대로 **너무 셌다**(LUA) — 삼각형 느낌표는
                    //  '조치하라' 는 경고 글리프인데 이건 상태 표시다.
                    //  맨 처음의 점과 다른 점: 그때는 글자가 기본색이라 점 혼자 싸웠다. 지금은 **글자가 이미
                    //  빨갛고** 점은 그 위에 얹는 마침표라, 같은 6px 이어도 신호가 훨씬 세다.
                    //  임박/초과는 색으로 가르지 않는다(LUA) — 단계와 수치는 호버 카드가 갖는다.
                    const cell = (
                      <span className="ckb">
                        {centers[ci]![0]}
                        {cn?.risk && <i className="cap-dot" aria-hidden />}
                      </span>
                    )
                    return (
                      <td
                        key={hr}
                        className={`rkcell ${hr === selHour ? 'colsel' : ''}${oi > 0 && hr === 0 ? ' dayb' : ''}${isPastHour(hr) ? ' is-past' : ''}${now ? ' nowcol' : ''}${edited ? ' exccol' : ''}${cn?.risk ? ' cap-risk' : ''}${unranked ? ' unranked' : ''}`}
                        title={now ? undefined : `${hr}시 ${unranked ? '순위 없음' : `${rank + storeRankOffset}위`} · ${centers[ci]![0]}`}
                        onClick={() => { if (!isFutureDay) onSelHour(hr) }}
                      >
                        {cn ? <Tooltip title={<CapaTip name={centers[ci]![0]} c={cn} />} placement="top">{cell}</Tooltip> : cell}
                      </td>
                    )
                  })}
                </tr>
              ))}
              {autoCenters === 'bottom' ? autoRow : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </Spin>
  )
}

// ── 글로벌 할당 우선순위(조회 뷰) — 원본 DispatchGlobalPriority 1:1 ────────────────────────────────────────
//   Alert·표·[수정]을 한 덩어리로 두는 이유: .gpwrap 의 폭을 표가 정하고 Alert 는 width:0·min-width:100% 로 그 폭에 접힌다 —
//   StyleOverride 로 펼 수 없는 CSS 트릭이라 트리로 풀지 않았다(값 보존).
interface GlobalPrioRow { key: string; rank: string; name: string }
export function GlobalPriority({ value, onEdit, centers = CENTERS }: { value: number[]; onEdit: () => void; centers?: [string, string][] }) {
  return (
    <div className="gpwrap">
      {/* 상단 안내(LUA) — 표와 같은 너비. 이 한 줄이 글로벌의 성격을 전부 설명: 운영/당일 예외 없이 기본 운영만 */}
      <Alert type="info" showIcon message="해외 출고는 기본운영 기준으로만 관리됩니다." />
      {/* 조회 표 = DS 표(core.Table). 종전엔 국내 탭과 같은 표 문법을 쓰려고 생 <table class="rk">을 그렸는데,
          그건 **시간 축(24열)·2단 스티키 헤더·열 선택**이 필요해서 생긴 구조다. 여기는 3행 2열 정적 표라
          그 사정이 없다 — 대응 DS 요소가 있으면 그걸 쓴다(CLAUDE.md 불변규칙 5, 2026-09-16 DS 감사).
          래퍼(.gpwrap)의 폭 트릭만 남는다: 표가 폭을 정하고 Alert 가 거기 접힌다. */}
      <Table
        className="gptbl"
        size="small"
        pagination={false}
        rowKey={(r: GlobalPrioRow) => r.key}
        columns={[
          { title: '순위', dataIndex: 'rank', width: 79, align: 'center' as const },
          { title: '센터', dataIndex: 'name', width: 300 },
        ]}
        dataSource={value.map((ci, i) => ({ key: String(ci), rank: `${i + 1}위`, name: centers[ci]![0] }))}
      />
      {/* 수정 = 기본 운영 모달의 [글로벌 할당 우선순위] 탭으로 진입 — 표 하단 우측(LUA) */}
      <div className="gpact">
        <Button onClick={onEdit}>수정</Button>
      </div>
    </div>
  )
}

// ── 모달 콘텐츠 폼 컨트롤 4종 — 원본 RankDragList·WaitSelect·DowPicker·GlobalPrioSlots 1:1 ────────────────
const GAP = 8 // .ranklist flex gap 과 동일하게 유지할 것(2026-09-16 간격 스케일 정리로 6→8)
interface DragState { ci: number; overIdx: number; y: number; grabDy: number; rowH: number; left: number; width: number }
/** 순위 행의 케파 상태 — 표(지금 열)와 **같은 어휘·같은 딱지**를 쓴다. 순위를 바꾸는 자리에서
 *  '이 센터가 얼마나 찼나' 가 곧 판단 재료다(LUA 2026-09-16: 예외 창에도 정보성으로). */
function RankCapa({ c }: { c: CapaNow | null }) {
  if (!c) return null
  if (c.off) return <div className="cap"><span className="cap-off">휴무</span></div>
  return (
    <div className="cap">
      {/* LOGISPRD-14424: capa null 이면 숫자 케파를 생략하고 ∞(무한)만, 주문 수도 없으면 '— /' 도 생략 */}
      <span className="cap-num">{c.capa == null
        ? `${c.orders != null ? `${c.orders.toLocaleString()} / ` : ''}${c.unl ? '∞' : '—'}`
        : <>{c.orders != null ? c.orders.toLocaleString() : '—'} / {c.capa.toLocaleString()}{c.unl && ' ∞'}</>}</span>
      {/* 딱지(임박·초과)는 걷었다 — 13줄짜리 목록에서 줄마다 딱지가 붙으면 정작 순위(번호·이름)보다
          딱지가 먼저 읽힌다. 위험은 **소진율 글자색 하나**로만 말한다(LUA 2026-09-16, 표와 같은 규칙:
          임박/초과를 색으로 가르지 않는다). 여기는 정보성 표시라 표처럼 아이콘까지 붙이지 않는다. */}
      {c.pct != null && <span className={`cap-pct${c.risk ? ' is-risk' : ''}`}>{c.pct}%</span>}
    </div>
  )
}
export interface RankDragListProps {
  /** 거점 목록 — 관리 단위(센터·스토어·글로벌센터)가 정한다(2026-09-14). 미지정이면 센터. */
  centers?: [string, string][]
  order: number[] // rank 위치 → 센터 index
  locked?: boolean // 지난 시간 등 읽기 전용
  showCapa?: boolean // 케파 상태 표시(예외 등록 창) — 기본/운영 설정 창은 날짜가 없어 끈다
  /** 센터별 케파 상태 — 예외 등록 창처럼 **날짜가 정해진** 목록에서만 넘어온다(스코프가 계산해 준다).
   *  종전엔 이 자리에 시드로 만든 '케파 N천/일' 을 그렸다 — 모델의 실제 케파와 무관한 가짜 숫자라
   *  같은 화면의 표(진짜 값)와 어긋났다(2026-09-16 제거). */
  capaOf?: (ci: number) => CapaNow | null
  /** 순서가 바뀌면 새 order 를 알린다. LOGISPRD-14424: ranked 를 받은 목록은 새 ranked 도 함께 알린다(없으면 undefined). */
  onChange: (next: number[], ranked?: number) => void
  /** 번호 시작값 보정 — 그룹으로 나눠 두 목록을 잇달아 그릴 때, 뒤 목록이 1 이 아니라 이어지는 번호로 시작한다
   *  (센터 13 + 스토어 6 = 19위까지 한 줄 순위. LUA 2026-09-29 그룹 분리). 미지정이면 0. */
  rankOffset?: number
  /** LOGISPRD-14424: 순위 구간 길이 — order 앞 ranked 개만 순위, 나머지는 '순위 없음' 구간(번호 '-').
   *  순위 없음 → 순위 구간으로 끌어 올리면 ranked+1, 순위 구간 → 순위 없음 으로 내리는 이동은 막는다.
   *  순위 없음 구간은 코드 오름차순 고정. 미지정이면 전부 순위(종전 동작). */
  ranked?: number
  /** LOGISPRD-16563: 'top' 이면 목록 맨 앞에 센터 묶음(전체 센터 자동 할당) 한 칸을 고정으로 두고 거점은 그다음 순위부터 센다.
   *  묶음은 order 밖의 표시 행이라 드래그 대상이 아니고 onChange 의 order·ranked 에도 들어가지 않는다.
   *  PriorityTable 의 autoCenters 와 달리 'top' 전용이다 — 'bottom'(묶음이 맨 뒤)은 표에만 있고 편집 목록에는 아직 쓰는 곳이 없다. */
  autoCenters?: 'top'
}
const numCls = (rank: number) => (rank === 1 ? 'n1' : rank === 2 ? 'n2' : rank === 3 ? 'n3' : 'nlo')
/** 순위 드래그 리스트 — 잡는 순간 행이 리스트에서 빠져 커서를 따라 떠다니고, 나머지 행들이 벌어져 놓일 위치가 보인다(포인터 이벤트 직접 구현). */
export function RankDragList({ autoCenters, ...props }: RankDragListProps) {
  if (autoCenters !== 'top') return <RankDragRows {...props} />
  // 묶음 칸 번호 = 거점 목록 오프셋 — 묶음이 맨 앞 한 칸이라 거점은 그 번호 다음부터 센다('top' 전용 불변식).
  const autoRank = (props.rankOffset ?? 0) + 1
  // 묶음 칸은 드래그 목록(안쪽 .ranklist) 밖에 둔다 — 안에 두면 놓을 위치 계산(행 높이·offsetTop)에 끼어든다.
  //  바깥 .ranklist 로 둘을 함께 감싸 묶음 칸과 첫 거점 행 사이도 행 간격(8px)과 같게 한다 — 부모 Flex 간격(기본·운영 창 12px)을 받지 않는다.
  return (
    <div className="ranklist">
      <div className="rankauto">
        <div className={`num ${numCls(autoRank)}`}>{autoRank}</div>
        <div className="autobody"><AutoCenterLabel /></div>
      </div>
      <RankDragRows {...props} rankOffset={autoRank} />
    </div>
  )
}
function RankDragRows({ order, locked, showCapa, capaOf, onChange, centers = CENTERS, rankOffset = 0, ranked }: Omit<RankDragListProps, 'autoCenters'>) {
  const listRef = useRef<HTMLDivElement>(null)
  const dragRef = useRef<DragState | null>(null)
  const [drag, setDragState] = useState<DragState | null>(null)
  const setDrag = (d: DragState | null) => { dragRef.current = d; setDragState(d) }
  const visible = drag ? order.filter((c) => c !== drag.ci) : order
  // LOGISPRD-14424: 순위 구간(R) — 끌고 있는 행이 순위 구간 행이면 보이는 목록의 순위 구간은 하나 줄어든다.
  const hasRanked = ranked !== undefined
  const R = hasRanked ? Math.max(0, Math.min(order.length, ranked)) : order.length
  const dragFromRanked = (ci: number) => order.indexOf(ci) < R
  const visibleRanked = drag && hasRanked ? (dragFromRanked(drag.ci) ? R - 1 : R) : R
  // 순위 구간에서 놓일 수 있는 마지막 삽입 위치 — 순위 구간 행은 구간 안, 순위 없음 행은 구간 끝 바로 뒤까지.
  const maxOver = (ci: number) => (dragFromRanked(ci) ? R - 1 : R)
  const showDivider = hasRanked && R < order.length
  // 떠 있는 동안 빈 공간이 순위 하나를 차지 — 공간 뒤 행들은 밀린 번호로 표시
  const rankOf = (idx: number) => rankOffset + (drag && idx >= drag.overIdx ? idx + 2 : idx + 1)
  const rankText = (idx: number): string => (idx < visibleRanked ? String(rankOf(idx)) : '-')
  // 커서 Y → 삽입 위치(0..visible.length). 행 중심선 기준 절반을 넘으면 다음 슬롯.
  const calcOver = (clientY: number, rowH: number) => {
    const top = listRef.current?.getBoundingClientRect().top ?? 0
    if (hasRanked) {
      // 구분선이 끼어 있어 등간격 계산이 어긋난다 — 행의 레이아웃 위치(transform 무시) 중심선으로 센다.
      const rows = Array.from(listRef.current?.querySelectorAll<HTMLElement>('.rankrow:not(.rank-float)') ?? [])
      const n = rows.filter((el) => top + el.offsetTop + el.offsetHeight / 2 < clientY).length
      return Math.max(0, Math.min(order.length - 1, n))
    }
    const step = rowH + GAP
    return Math.max(0, Math.min(order.length - 1, Math.round((clientY - top - rowH / 2) / step)))
  }
  /** 놓기 — ranked 가 없으면 종전 그대로. 있으면 구간 규칙을 적용하고 순위 없음 구간을 코드순으로 정리한다. */
  const drop = (ci: number, overIdx: number) => {
    const rest = order.filter((c) => c !== ci)
    if (!hasRanked) { rest.splice(overIdx, 0, ci); onChange(rest); return }
    const fromRanked = dragFromRanked(ci)
    if (!fromRanked && overIdx > R) return // 순위 없음 구간 안 재정렬은 의미가 없다(코드순 고정)
    rest.splice(Math.min(overIdx, maxOver(ci)), 0, ci)
    const nextRanked = fromRanked ? R : R + 1
    const code = (x: number) => centers[x]?.[1] ?? ''
    // 코드포인트 비교 — realApi byCode 와 같은 기준(로캘 무관)
    const tail = rest.slice(nextRanked).sort((a, b) => { const x = code(a); const y = code(b); return x < y ? -1 : x > y ? 1 : 0 })
    onChange([...rest.slice(0, nextRanked), ...tail], nextRanked)
  }
  const startDrag = (e: React.PointerEvent, ci: number, idx: number) => {
    if (locked || e.button !== 0) return
    e.preventDefault()
    const r = (e.currentTarget as HTMLElement).getBoundingClientRect()
    setDrag({ ci, overIdx: idx, y: e.clientY, grabDy: e.clientY - r.top, rowH: r.height, left: r.left, width: r.width })
    const onMove = (ev: PointerEvent) => {
      const d = dragRef.current
      if (!d) return
      setDrag({ ...d, y: ev.clientY, overIdx: calcOver(ev.clientY, d.rowH) })
    }
    const cleanup = () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', onUp)
      window.removeEventListener('pointercancel', onCancel)
    }
    const onUp = () => {
      const d = dragRef.current
      if (d) drop(d.ci, d.overIdx)
      setDrag(null)
      cleanup()
    }
    const onCancel = () => { setDrag(null); cleanup() }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    window.addEventListener('pointercancel', onCancel)
  }
  return (
    <div
      ref={listRef}
      className={`ranklist ${drag ? 'is-dragging' : ''}`}
      // 떠 있는 행 몫의 빈 공간(마지막 슬롯일 때 포함)을 컨테이너 높이로 확보
      style={drag ? { paddingBottom: drag.rowH + GAP } : undefined}
    >
      {visible.map((ci, idx) => (
        <Fragment key={ci}>
        {/* LOGISPRD-14424: 순위 구간과 순위 없음 구간 사이 구분선(ranked 를 받은 목록만). 빈 칸이 구분선 앞에서 열리면 구분선도 함께 민다 */}
        {showDivider && idx === visibleRanked && (
          <core.Divider
            dashed
            className="allocation-priority-unranked-divider"
            style={drag ? { transform: visibleRanked >= drag.overIdx ? `translateY(${drag.rowH + GAP}px)` : 'translateY(0)', transition: 'transform 150ms ease' } : undefined}
          >순위 없음</core.Divider>
        )}
        <div
          key={ci}
          className={`rankrow ${locked ? 'locked' : ''}${idx >= visibleRanked ? ' unranked' : ''}`}
          // 삽입 위치 이후 행들을 아래로 밀어 빈 공간을 연다 — transform 트랜지션으로 부드럽게
          style={drag ? { transform: idx >= drag.overIdx ? `translateY(${drag.rowH + GAP}px)` : 'translateY(0)', transition: 'transform 150ms ease' } : undefined}
          onPointerDown={(e) => startDrag(e, ci, idx)}
        >
          <div className={`num ${idx < visibleRanked ? numCls(rankOf(idx)) : 'nlo'}`}>{rankText(idx)}</div>
          <div className="nm">{centers[ci]![0]}</div>
          {showCapa && <RankCapa c={capaOf?.(ci) ?? null} />}
          {/* 문자(🔒·⠿) 대신 DS 아이콘 — 이모지는 글꼴에 따라 모양·굵기·색이 달라지고(컬러 이모지는 색 토큰도 안 먹는다),
              점자 패턴(⠿)은 드래그 손잡이를 흉내 낸 것일 뿐 그 뜻을 갖지 않는다(2026-09-16 DS 아이콘 정리). */}
          <div className="grip"><DsIcon name={locked ? 'ic-lock' : 'ic-dragHandle'} size={16} color="currentColor" /></div>
        </div>
        </Fragment>
      ))}
      {/* 커서를 따라 떠다니는 행 — 목표 순위 번호가 실시간 갱신 */}
      {drag && (() => {
        // LOGISPRD-14424: ranked 목록은 놓일 수 있는 순위(구간 끝으로 클램프), 순위 없음 구간에 놓이면 '-'
        const floatRank = !hasRanked ? drag.overIdx + 1 : !dragFromRanked(drag.ci) && drag.overIdx > R ? null : Math.min(drag.overIdx, maxOver(drag.ci)) + 1
        return (
        <div
          className="rankrow rank-float"
          style={{ left: drag.left, width: drag.width, top: drag.y - drag.grabDy }}
        >
          <div className={`num ${floatRank == null ? 'nlo' : numCls(rankOffset + floatRank)}`}>{floatRank == null ? '-' : rankOffset + floatRank}</div>
          <div className="nm">{centers[drag.ci]![0]}</div>
          {showCapa && <RankCapa c={capaOf?.(drag.ci) ?? null} />}
          <div className="grip"><DsIcon name="ic-dragHandle" size={16} color="currentColor" /></div>
        </div>
        )
      })()}
    </div>
  )
}

/** 출고대기시간 입력 — 30분 단위·최대 9시간(540분). 보정 시점 = blur/Enter(타이핑 중 값이 튀지 않게). */
export function WaitSelect({ value, onChange, disabled }: { value: number; onChange: (v: number) => void; disabled?: boolean }) {
  const [raw, setRaw] = useState<number | null>(value) // 입력 중 임시값(미보정) — 확정은 blur/Enter
  useEffect(() => { setRaw(value) }, [value])
  const commit = () => {
    // LOGISPRD-14424: 입력을 바꾸지 않았으면(포커스만 줬다 뺌) 서버값(예: 5분)을 30분 단위로 보정하지 않는다
    if (raw === value) return
    const v = Math.max(0, Math.min(WAIT_MAX, Math.round(((raw ?? 0) as number) / 30) * 30))
    setRaw(v)
    if (v !== value) onChange(v)
  }
  return (
    <span className="waitsel">
      <InputNumber
        style={{ width: 130 }}
        min={0}
        max={WAIT_MAX}
        step={30}
        addonAfter="분"
        disabled={disabled}
        value={raw}
        onChange={setRaw}
        onBlur={commit}
        onPressEnter={commit}
      />
      {/* 입력 규칙은 고칠 수 있을 때만 뜬다 — 조회 화면에서 '30분 단위로 입력하라'는 할 수 없는 일의 안내다. */}
      {!disabled && <span className="lbl-hint">30분 단위 · 최대 9시간</span>}
    </span>
  )
}

/** 요일 선택 칩 — 다중 선택, 일/토 색상, tone(primary/danger), disabled(사용 중). */
export interface DowPickerProps {
  value: number[] // 선택된 요일 (0=일 ~ 6=토)
  onChange: (next: number[]) => void
  tone?: 'primary' | 'danger' // 선택 색 — 기본 파랑, 휴무 등 부정 의미는 빨강
  disabledDays?: number[] // 선택 불가 요일(다른 곳에서 사용 중 등)
}
export function DowPicker({ value, onChange, tone = 'primary', disabledDays = [] }: DowPickerProps) {
  return (
    <div className={`lg-dowpick ${tone === 'danger' ? 'is-danger' : ''}`}>
      {DOW7.map((d, i) => {
        const on = value.includes(i)
        const dis = !on && disabledDays.includes(i)
        return (
          <button
            key={i}
            type="button"
            disabled={dis}
            title={dis ? '사용 중' : ''}
            className={`lg-dow ${on ? 'on' : ''} ${i === 0 ? 'sun' : i === 6 ? 'sat' : ''} ${dis ? 'dis' : ''}`}
            onClick={() => onChange(on ? value.filter((x) => x !== i) : [...value, i].sort())}
          >
            {d}
          </button>
        )
      })}
    </div>
  )
}

/** 글로벌 할당 우선순위 편집 슬롯 — 1·2·3순위 셀렉트, 중복 센터는 타 순위 disabled. */
// 시임인 이유는 **상호 배제**다 — 한 센터를 두 순위에 둘 수 없어 슬롯끼리 서로의 값을 봐야 한다(트리로는 못 편다).
//  라벨·행 규격은 시임이 정할 일이 아니다: 종전엔 `.gprio-rk`(12/600/보조)로 FormItem 라벨 시각을 손으로 흉내 냈다
//  — 같은 모달의 다른 폼 행과 라벨 폭·정렬이 따로 놀았다(LUA 2026-09-16). 행은 DS 폼 행(core.FormItem)으로 세운다.
//  labelWidth 88 = DS 기본(모달 폼 행 규약) · boxedItem 기본 true → 폭은 DS 가 정한다(수동 240 제거).
export function GlobalPrioSlots({ value, onChange, centers = CENTERS }: { value: number[]; onChange: (v: number[]) => void; centers?: [string, string][] }) {
  return (
    <div className="gprio-row">
      {[0, 1, 2].map((slot) => (
        <FormItem key={slot} label={`${slot + 1}순위`} labelPosition="left" labelWidth={88}>
          <Select
            style={{ width: '100%' }}
            value={value[slot]}
            options={centers.map((c, ci) => ({ value: ci, label: c[0], disabled: value.includes(ci) && value[slot] !== ci }))}
            onChange={(ci) => onChange(value.map((v, i) => (i === slot ? ci : v)))}
          />
        </FormItem>
      ))}
    </div>
  )
}

